module.exports = __webpack_public_path__ + "media/200513_YEAH_CI_neuer_Look_Y_Flip_002.1f6d83ea.mp4";